<div class="container-fluid">
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">{{headerText}}</h1>
    </div>
  </div>

  <div class="row no-gutters">
    <div class="col-xs-2">
      <b>Show all from my Department?: </b>
         <mat-checkbox
          id="ShowAllFromMyDept"
          name="ShowAllFromnMyDept"
          [(ngModel)]="showAllFromMyDept"
          (change)="handleShowAllFromMyDept()"
      >
      </mat-checkbox>
    </div>
    <div class="col-xs-2">
      <b>Show all Depts?: </b>
        <mat-checkbox
          id="Show all Depts"
          name="Show all Depts"
          [(ngModel)]="showAllDepts"
          (change)="handleShowAllDepts()"
      >
      </mat-checkbox>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <aims-common-table id="qual-approval-table"
          [dataSource]="qualsAwaitingApproval"
          [header]="tableHeader"
          [pageSize]="15"
          [permissions]="tablePermissions">

        <aims-common-table-dynamic-row id="button" >
          <ng-template viewMode let-element let-idx="idx">
            <aims-common-button-mini
              *ngIf="element.employeeId != empId"
              (click)="updateQualRequired(element)"
              title="Toggle Required"
              aria-label="Toggle Required">
                <span class="primary-text">  {{ (element.qualNotRequired) ? '+Req' : '-Req' }} </span>
            </aims-common-button-mini>

            <aims-common-button-mini
              *ngIf="element.employeeId != empId || element.deptManagerId == empId"
              (click)="approveQualificaiton(element, idx)"
              title="Approve"
              aria-label="Approve">
                <span class="primary-text"> App </span>
            </aims-common-button-mini>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="qualNotRequired">
          <ng-template viewMode let-element>
            <mat-checkbox [checked]="!element.qualNotRequired" disabled="true"></mat-checkbox>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="qualOwnerDeptId">
          <ng-template viewMode let-element>
            {{ element.qualOwnerDeptId | getText:'departmentId':'department':departmentValues | async }}
          </ng-template>
          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" class="top20 fullWidth">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter"
                [ngModelOptions]="{standalone: true}">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let d of departmentValues | async" [value]="d.departmentId">
                  {{d.department}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <ng-template aimsCommonTableExpandedRow let-element >
          <div style="flex-wrap: wrap; width:100%">
            <div class="col-md-6" style="width: 100%;">
              <aims-common-table
                    id="qual-task-sub-table"
                    [dataSource]="element.qtDetails"
                    [header]="subTableHeader"
                    [permissions]="subTablePermissions"
                    pageSize="5"
                    [stickyHeader]="true">

                <aims-common-table-dynamic-row id="button">
                  <ng-template viewMode let-element >
                    <aims-common-button-mini *ngIf="element.employeeId != empId"
                          (click)="updateQtRequired(element)"
                          title="Toggle Required"
                          aria-label="Toggle Required">
                       <span class="primary-text"> {{ (element.qtNotRequired) ? '+Req' : '-Req' }}</span>
                    </aims-common-button-mini>

                    <aims-common-button-mini *ngIf="element.employeeId != empId"
                          (click)="openRevokeComment(element)"
                          title="Revoke"
                          aria-label="Revoke">
                       <span class="primary-text">Rev</span>
                    </aims-common-button-mini>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="qtNotRequired">
                  <ng-template viewMode let-element>
                    <mat-checkbox [checked]="!element.qtNotRequired" disabled="true"></mat-checkbox>
                  </ng-template>
                </aims-common-table-dynamic-row>

              </aims-common-table>
            </div>
          </div>
        </ng-template>
      </aims-common-table>
    </div>
  </div>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>

</div>
